// extracted by mini-css-extract-plugin
export default {"value":"DescriptionDetails_value__G0BFr","wrapper":"DescriptionDetails_wrapper__JYAUb","margins":"DescriptionDetails_margins__St+im"};